module.exports = __webpack_public_path__ + "img/racodemar.ecb0dd6b.jpg";